import React , { useEffect, useState, Fragment } from 'react';
import { Link } from "react-router-dom";
import { getEventList } from '../../Service';
import { getAdminSubscription } from '../../Service';
import Swal from "sweetalert2";
import { useSelector} from 'react-redux';
import { Form, Button, Row, Col, ListGroup, Table, ButtonGroup } from "react-bootstrap";
import moment from 'moment';
import ClipLoader from "react-spinners/ClipLoader";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "#96D2CE",
};

export default function EventAppHome(){ 

  const [list, setList] = useState([]);
  const current = new Date();
  const TodayDate = `${current.getFullYear()}-${(current.getMonth() + 1).toString().padStart(2, "0")}-${current.getDate()}`;
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState(true);
  const [color, setColor] = useState("#ffffff");
  
  let loggedUser = useSelector(store => store.user['user'])
  let user_id = '';
  if(loggedUser){
    user_id = loggedUser.id
  }
  


useEffect(() => {
  //getEventList().then(res => handleResponse(res))
  getEventList().then(res => setList(res.data.data.event.items ))
},[]);

const dateExpire = () =>{
  Swal.fire({
    position: 'center',
    icon: 'warning',
    title: 'Application Date is Expired for this Event.',
    showConfirmButton: false,
    timer: 1500
  })
}

useEffect(() => {
  let params = { 'exihibitor_list': 1, 'id': user_id };
  getAdminSubscription(params).then(res => handleSubscribeResponse(res))
}, []);

const handleSubscribeResponse = (response) => {
  console.log(response);
  if(response.data.code==400){ //IF Token Expired......
      const errors = {};
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: response.data.message,
      })
      setLoad(false);
    }else if(response.data.code==200){  //IF Request is Success
      setSubscriptionData(response.data.data.subscription.items);
      setLoad(false);
    }
}

// const handleResponse = (response) => {
//   console.log('response',response)
// }


console.log('check list', list)
const paymentButton =(data)=>{
 return data.map((item)=>{
    return (
      <Fragment>
      {/* <Link to={'/eventapplication/'+item.id} className='bg'>Applied</Link> */}
      
      {/* <Link to={'/dashboard/'+item.id} className='bgb'>{item.event_status=='approve' ? 'View Dashboard' : item.event_status}</Link>  */}
      <Link to={'#'} className='grybtn'>Applied</Link> 
    </Fragment>
    )
  })
 
}


const openPopup = (subscribe, buySubscribe) => {
  console.log(subscribe);
  console.log(buySubscribe);
  Swal.fire({
    title: 'SUBSCRIPTION DETAILS', 
    html: "<section className='admin-section'><div className='container'><div className='row'><div className='col-md-12 col-12'><div className='admin-edit gallery-guide'><div className='table-responsive'><Table striped><tbody><tr><td>   Item<br /><i>"+subscribe.sub_name+"</i></td><td>Paid Date<br /><i>"+moment(buySubscribe.paid_date).format('MM-DD-YYYY')+"</i></td><td>Expire Date<br /><i>"+moment(buySubscribe.expire_date).format('MM-DD-YYYY')+"</i></td><td>Price<br /><i>$"+buySubscribe.paid_price +"USD</i></td></tr></tbody></Table></div></div></div></div></div></section>", 
  });
}

// if (Object.keys(list).length >0) {
//   setLoading(false);
// }

return(
<>
<section className="sec-container" >
<div className='container'>
   <div className='event'>
  
   <div className='row'>
   <div className='co1-md-12'>
    <h2>Welcome to the photo l.a. Exhibitor Portal!</h2>

    <h1>Event</h1>
    {/* <h4>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</h4> */}
   <p className='green-txt'>Select an event below to view all relevant show information and forms you need to complete.</p>
 
   </div>
    </div>

    {
   Object.keys(list).length === 0 ?
   <h1 align={'center'}>No Events Found</h1>
    :
    <div className='row'>



    {
  list.map(data => (

    <div className='col-md-12 col-12'>
    <div className='event-col'>
      <div className='row'>
      <div className='col-md-3 col-12 middle-aln'>
        <div>
          <h2>{data.event_name}</h2>
          <h3>{data.event_location}</h3>
        </div>
    </div>
    <div className='col-md-4 col-12 middle-aln'>
    <p>My Event Status: {data.status=='2' ? 'Public' : 'Draft'}</p>
    </div>
    <div className='col-md-5 col-12 middle-aln'>
    <div className='buttons'>
    {/* <Link to={'/eventapplication?event_id='+data.id} className='bg'>Apply for Event</Link> */}
    {data.payment.length?
      paymentButton(data.payment)
      :
     ""
    }

    {/* <Link to={'/dashboard/'+data.id} className='dashbtn'>Dashboard Coming Soon</Link> */}
    {
        // data.finalpayment_date >= TodayDate ?
          <Link to={'/eventapplication/'+data.id} className='bg'>Apply for Event</Link> 
          // :
          // <Link to="#" onClick={dateExpire} className='bg'>Apply for Event</Link>

    }

    </div>
</div>
    </div>
    </div>
    </div>
  ))
}

    
     

      
      
    </div>
  }
  </div>
</div>

</section>  

<section className="subs-container" >
<div className='container'>
   <div className='subscrt'>
   <div className='row'>
   <div className='co1-md-12'>
    <h1>SUBSCRIPTIONS</h1>
    <h4 ><p className='green-txt'>Partner with photo l.a. online and enjoy a broader reach</p></h4>
   </div>
    </div>
{
  load ? <ClipLoader color={color} loading={loading} cssOverride={override} size={250} /> :
    <div className='row'>
{
    subscriptionData.map( subData => (
    
      

      <div className='col-md-12 col-12'>
        <div className='subscription'>
        <div className='row'>
        <div className='col-md-3 col-12 middle-aln'>
        <h2>{subData.sub_name}</h2>
        </div>
        <div className='col-md-4 col-12 middle-aln'>
        { 
        Object.keys(subData.by_subscription).length === 0 ?  
        <p>My Subscription Status<br/>Not Subscribed</p>
          : <p>My Subscription Status<br/>End [{moment(subData.by_subscription[0].expire_date).format('MM-DD-YYYY')}]</p>
          
        }
        </div>
        <div className='col-md-5 col-12 middle-aln'>
        <div className='buttons'>
      {
          subData.by_subscription.map( buySub => (
          <Link to='#' className='bgb' onClick={()=>openPopup(subData, buySub)}>Subscription Details</Link> 
          ))


        
      }

      { Object.keys(subData.by_subscription).length === 0 ? <Link to={ `/exhibitor-subscription/${subData.id}` } className='bg'>Sign Up</Link> : '' }
      
        </div>
        </div>
        </div>
      </div>
      </div>

    ))
}
 
  </div>
}
</div>
</div>

</section>  

</>
)
}
